import {Action} from "@ngrx/store";

export const LOAD_USER: string = '[user] Load User';
export const LOAD_USER_SUCCESS: string = '[user] Load User Success';
export const LOAD_USER_FAIL: string = '[user] Load User Fail';

export const LOAD_USER_SUBSCRIPTION: string = '[user] Load User Subscription';
export const LOAD_USER_SUBSCRIPTION_SUCCESS: string = '[user] Load User Subscription Success';
export const LOAD_USER_SUBSCRIPTION_FAIL: string = '[user] Load User Subscription Fail';
export const UPDATE_USER_SUBSCRIPTION: string = '[user] Update User Subscription';

export const LOAD_USER_AVAILABLE_SUBSCRIPTIONS: string = '[user] Load User Subscriptions';
export const LOAD_USER_AVAILABLE_SUBSCRIPTIONS_SUCCESS: string = '[user] Load User Subscriptions Success';
export const LOAD_USER_AVAILABLE_SUBSCRIPTIONS_FAIL: string = '[user] Load User Subscriptions Fail';

export const LOAD_USER_REFERRAL_SUBSCRIPTION: string = '[user] Load User Referral Subscription';
export const LOAD_USER_REFERRAL_SUBSCRIPTION_SUCCESS: string = '[user] Load User Referral Subscription Success';
export const LOAD_USER_REFERRAL_SUBSCRIPTION_FAIL: string = '[user] Load User Referral Subscription Fail';

export const LOAD_PLAN_DESCRIPTION_MAP: string = '[user] Load Plan Description Map';
export const LOAD_PLAN_DESCRIPTION_MAP_SUCCESS: string = '[user] Load Plan Description Map Success';
export const LOAD_PLAN_DESCRIPTION_MAP_FAIL: string = '[user] Load Plan Description Map Fail';

export const USER_LOG_IN: string = '[user] User Log In';
export const UPDATE_USER_DATA: string = '[user] Update User Data';
export const USER_LOG_OUT: string = '[user] User Log Out';

export class LoadUser implements Action {

  readonly type: string = LOAD_USER;

}

export class LoadUserSuccess implements Action {

  readonly type: string = LOAD_USER_SUCCESS;
  constructor(public payload: any) {}

}

export class LoadUserFail implements Action {

  readonly type: string = LOAD_USER_FAIL;
  constructor(public payload: string) {}

}

export class LoadUserSubscription implements Action {

  readonly type: string = LOAD_USER_SUBSCRIPTION;

}

export class LoadUserSubscriptionSuccess implements Action {

  readonly type: string = LOAD_USER_SUBSCRIPTION_SUCCESS;
  constructor(public payload: any) {}

}

export class LoadUserSubscriptionFail implements Action {

  readonly type: string = LOAD_USER_SUBSCRIPTION_FAIL;
  constructor(public payload: string) {}

}

export class UpdateUserSubscription implements Action {

  readonly type: string = UPDATE_USER_SUBSCRIPTION;

}

export class LoadUserAvailableSubscriptions implements Action {

  readonly type: string = LOAD_USER_AVAILABLE_SUBSCRIPTIONS;

}

export class LoadUserAvailableSubscriptionsSuccess implements Action {

  readonly type: string = LOAD_USER_AVAILABLE_SUBSCRIPTIONS_SUCCESS;
  constructor(public payload: {platform: any, booster: any, ai: any, meta: any}) {}

}

export class LoadUserAvailableSubscriptionsFail implements Action {

  readonly type: string = LOAD_USER_AVAILABLE_SUBSCRIPTIONS_FAIL;
  constructor(public payload: string) {}

}

export class LoadUserReferralSubscription implements Action {

  readonly type: string = LOAD_USER_REFERRAL_SUBSCRIPTION;

}

export class LoadUserReferralSubscriptionSuccess implements Action {

  readonly type: string = LOAD_USER_REFERRAL_SUBSCRIPTION_SUCCESS;
  constructor(public payload: any) {}

}

export class LoadUserReferralSubscriptionFail implements Action {

  readonly type: string = LOAD_USER_REFERRAL_SUBSCRIPTION_FAIL;
  constructor(public payload: string) {}

}

export class LoadPlanDescriptionMap implements Action {

  readonly type: string = LOAD_PLAN_DESCRIPTION_MAP;

}

export class LoadPlanDescriptionMapSuccess implements Action {

  readonly type: string = LOAD_PLAN_DESCRIPTION_MAP_SUCCESS;
  constructor(public payload: any) {}

}

export class LoadPlanDescriptionMapFail implements Action {

  readonly type: string = LOAD_PLAN_DESCRIPTION_MAP_FAIL;
  constructor(public payload: string) {}

}

export class UserLogIn implements Action {

  readonly type: string = USER_LOG_IN;

}

export class UpdateUserData implements Action {

  readonly type: string = UPDATE_USER_DATA;
  constructor(public payload: any) {}

}

export class UserLogOut implements Action {

  readonly type: string = USER_LOG_OUT;

}

export type UserAction = LoadUser | LoadUserSuccess | LoadUserFail
  | LoadUserSubscription | LoadUserSubscriptionSuccess | LoadUserSubscriptionFail | UpdateUserSubscription
  | LoadUserAvailableSubscriptions | LoadUserAvailableSubscriptionsSuccess | LoadUserAvailableSubscriptionsFail
  | LoadUserReferralSubscription | LoadUserReferralSubscriptionSuccess | LoadUserReferralSubscriptionFail
  | LoadPlanDescriptionMap | LoadPlanDescriptionMapSuccess | LoadPlanDescriptionMapFail
  | UserLogIn | UpdateUserData | UserLogOut;
